<template>
    <div>
      <div class="vx-card">
        <div class="vx-card__body card-body p-10">
          <div class="mb-24">
            <div class="flex gap-5">
              <div class="vx-col lg:w-1/2 w-full mt-1">
                <label class="vs-select--label">{{ $t("Agent") }}</label>
                <treeselect
                  name="agent"
                  :multiple="false"
                  :placeholder="$t('SearchAgent')"
                  :async="true"
                  :load-options="loadOptions"
                  v-validate="'required'"
                  class="search-input"
                  ref="agent"
                  @select="onAgentSelected"
                />
              </div>
              <!-- <div class="vx-col lg:w-1/2 w-full">
                <label class="vs-select--label datepicker-lb">{{
                  $t("Date")
                }}</label>
                <date-picker
                  v-model="model.date"
                  type="datetime"
                  format="jYYYY-jMM-jDD HH:mm:ss"
                  display-format="jYYYY-jMM-jDD HH:mm:ss"
                  class="date-picker"
                  :label="$t('Date')"
                  :clearable="true"
                />
              </div> -->
            </div>
            <hr class="my-5" />
            <div class="mt-5 flex gap-5">
              <div class="vx-col lg:w-2/3 w-full">
                <label class="vs-select--label">{{ $t("Product") }}</label>
                <treeselect
                  name="agent"
                  :multiple="false"
                  :placeholder="$t('SearchProduct')"
                  :async="true"
                  :load-options="loadOptionsProduct"
                  v-validate="'required'"
                  class="search-input"
                  ref="product"
                  @select="onActualProductSelected($event)"
                />
              </div>
              <div>
                <vs-input
                  class="inputx"
                  v-model="model.count"
                  :label="$t('Count')"
                />
              </div>
              <vs-button
                class="btn-drop vs-component vs-button bg_l_green bg-danger mt-6"
                color="success"
                icon="add"
                @click.prevent="AddAccounts(model)"
              ></vs-button>
            </div>
            <table
              v-if="selectedProducts.length > 0"
              class="basic-tbl mt-10"
              id="colored-table"
            >
              <thead>
                <tr>
                  <th>{{ $t("Product") }}</th>
                  <th>{{ $t("ItemCode") }}</th>
                  <th>{{ $t("Count") }}</th>
                  <th>{{ $t("Action") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(account, i) in selectedProducts">
                  <!-- <td style="width: 10%">
                    <span v-if="account.accountType == 1">گروه حساب</span>
                    <span v-if="account.accountType == 2">حساب کل</span>
                    <span v-if="account.accountType == 3">حساب معین</span>
                    <span v-if="account.accountType == 4">حساب تفضیلی</span>
                    <span v-if="account.accountType == 5">حساب شناوری</span>
                  </td> -->
                  <td>
                    <span>
                      {{ account.label ? account.label : "" }}
                    </span>
                  </td>
                  <td>
                    <span>
                      {{ account.itemCode ? account.itemCode : "" }}
                    </span>
                  </td>
                  <td>
                    <span>
                      {{ account.count ? account.count : "" }}
                    </span>
                  </td>
                  <td style="width: 10%">
                    <vs-button
                      radius
                      color="danger"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-x"
                      @click.prevent="deleteAccount(i)"
                      class="d-inline remove-btn flex-shrink-0"
                    ></vs-button>
                  </td>
                </tr>
              </tbody>
            </table>
            <vs-button
              v-if="selectedProducts.length > 0"
              type="filled"
              class="float-right mb-4 mt-12"
              :disabled="!agentId"
              @click.prevent="submitForm"
              >{{ $t("Save") }}</vs-button
            >
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import { mapActions } from "vuex";
  import { Validator } from "vee-validate";
  import vSelect from "@/components/CustomVSelect.vue";
  import Treeselect from "@/components/CustomTreeSelect.vue";
  import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
  
  const dict = {
    custom: {
      CreateOn: {
        required: "لطفا تاریخ درج را وارد نمایید.",
      },
  
    },
  };
  
  Validator.localize("fa", dict);
  export default {
    components: {
      Treeselect,
      "v-select": vSelect,
    },
    data() {
      return {
        searchQueryNew: "",
        searchQueryOld: "",
        searchQueryProductNew: "",
        searchQueryProductOld: "",
        selectedProducts: [],
        labels: [],
        labelPersian: "",
        labelEnglish: "",
        productInfo: {},
        product: null,
        agentId: null,
        agentInfo: {},
        model: {},
      };
    },
  
    methods: {
      ...mapActions({
        fetchSearch: "parties/channelAgentsSearch",
        searchProduct: "productQuery/productQuery",
        createDischarge: "productQuery/createDischarge",
      }),
      onActualProductSelected(data) {
        this.labels = data.label.split("   ---   ");
        this.labelPersian = this.labels[0];
        this.labelEnglish = this.labels[1];
        this.productInfo.actualProductId = data.id;
        this.product = null;
        this.model.itemCode = data.itemCode;
        this.model.label = data.label;
      },
      loadOptionsProduct({ searchQuery, callback }) {
        this.searchQueryProductNew = searchQuery;
        this.searchQueryProductOld = this.searchQueryProductNew;
        setTimeout(() => {
          this.searchQueryProductNew = searchQuery;
          if (this.searchQueryProductOld == this.searchQueryProductNew) {
            this.searchProduct(searchQuery).then((response) => {
              const options = [];
              response.forEach(function (element) {
                options.push({
                  id: element.id,
                  itemCode: element.itemCode,
                  label: element.persianName + "   ---   " + element.name,
                });
              });
              callback(null, options);
            });
          }
        }, 2000);
      },
      loadOptions({ action, searchQuery, callback }) {
        this.searchQueryNew = searchQuery;
        this.searchQueryOld = this.searchQueryNew;
        setTimeout(() => {
          this.searchQueryNew = searchQuery;
          if (this.searchQueryOld == this.searchQueryNew) {
            if (action === ASYNC_SEARCH) {
              this.fetchSearch(searchQuery).then((r) => {
                const options = [];
                r.forEach(function (element) {
                  options.push({
                    id: element.id,
                    label: element.name,
                  });
                });
                callback(null, options);
              });
            }
          }
        }, 2000);
      },
      onAgentSelected(data) {
        this.agentId = data.id;
      },
      AddAccounts(model) {
        if(model.count && model.itemCode){
  
          var index=this.selectedProducts.findIndex((x)=>x.itemCode===model.itemCode)
        if(index===-1){
          this.selectedProducts.push(model);
        this.model = {};
  
        }
        else{
          this.$swal({
            position: "center-center",
            type: "error",
            text: "کالا انتخابی تکراری می باشد!",
            showConfirmButton: false,
            timer: 8000,
          });      }
        }
  
      },
      deleteAccount(index) {
        this.$swal({
          title: "آیا از حذف این رکورد اطمینان دارید؟",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بلی",
          cancelButtonText: "خیر",
        }).then((result) => {
          if (result.value) {
            this.selectedProducts.splice(index, 1);
          }
        });
      },
      submitForm(){
        var payload={
          saleAgentId:this.agentId,
          expireClock:this.model.date,
          quotaInfosCommand:this.selectedProducts
        }
        this.createDischarge(payload).then(() => {
          this.$swal({
            position: "center-center",
            type: "success",
            text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
            showConfirmButton: false,
            timer: 2000,
          });
          this.$router.push(-1);
  
        });
      }
  
    },
  };
  </script>
  <style>
  body[dir="rtl"] table thead th{
    position: static;
  }</style>